export default "__VITE_ASSET__rPEVeO6t9ic9_Oe1zgoLYQ__"